import { CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import ConfigurationKeys from './keys'
import EmailConfigPresenter from './presenter_email_tab'
import ConfigurationTabsScope, { ConfigurationTabsOption, HeaderScope } from './scopes'
import EmailTemplatePresenter from './presenter_template_email_tab'
import NotificationTabPresenter from './presenter_notification_tab'
import ManageTypesPresenter from './presenter_manage_types'
import BillingConfigPresenter from './presenter_billing_tab'

const LOG = Logger.get('ConfigurationPresenter')

export class ConfigurationPresenter extends CubePresenter<MainPresenter, ConfigurationTabsScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, ConfigurationPresenter>

    // private readonly __parent: ConfigurationPresenter

    private readonly __emailsConfig: EmailConfigPresenter
    private readonly __emailsTemplate: EmailTemplatePresenter
    private readonly __notificationTab: NotificationTabPresenter
    private readonly __managerNotificationTypes: ManageTypesPresenter
    private readonly __billingConfig: BillingConfigPresenter

    #selectedConfigTab?: string
    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new ConfigurationTabsScope())
        this.__headerBar = new Presenter(this, this.scope.header)

        // this.__parent = owner

        // Tabs
        this.__emailsConfig = new EmailConfigPresenter(this)
        this.__emailsTemplate = new EmailTemplatePresenter(this)
        this.__notificationTab = new NotificationTabPresenter(this)
        this.__managerNotificationTypes = new ManageTypesPresenter(this)
        this.__billingConfig = new BillingConfigPresenter(this)
    }

    // :: Methods

    public override release() {
        this.__emailsConfig.release()
        this.__emailsTemplate.release()
        this.__notificationTab.release()
        this.__managerNotificationTypes.release()
        this.__billingConfig.release()

        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.active = toConfigurationTabsOption(this.#selectedConfigTab)
        this.scope.onSelect = this.action(this.handleTabSelected)

        await this.__emailsConfig.initialize()
        await this.__emailsTemplate.initialize()
        await this.__notificationTab.initialize()
        await this.__managerNotificationTypes.initialize()
        await this.__billingConfig.initialize()
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new ConfigurationKeys(this.app, intent)
        keys.selectedConfigTab = this.#selectedConfigTab
        LOG.debug(`publishParameters ${keys.selectedConfigTab}`)
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new ConfigurationKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }

        return keys.allow
    }

    private async handleTabSelected(tab: ConfigurationTabsOption) {
        this.scope.active = tab
        this.app.updateHistory()

        if (tab === 'email') {
            await this.__emailsConfig.onLoadData()
            return
        }
        if (tab === 'email-template') {
            await this.__emailsTemplate.onLoadData()
            return
        }
        if (tab === 'notifications') {
            await this.__notificationTab.onLoadData()
            return
        }
        if (tab === 'billing') {
            await this.__billingConfig.onLoadData()
            return
        }
    }
}

export default ConfigurationPresenter

function toConfigurationTabsOption(v: string | undefined | null): ConfigurationTabsOption {
    if (v === 'email-template') return 'email-template'
    if (v === 'email') return 'email'
    if (v === 'notifications') return 'notifications'
    if (v === 'billing') return 'billing'
    return 'email'
}
